import { render, staticRenderFns } from "./DatePicker.html?vue&type=template&id=4220c986&scoped=true&"
import script from "./DatePicker.ts?vue&type=script&lang=ts&"
export * from "./DatePicker.ts?vue&type=script&lang=ts&"
import style0 from "./DatePicker.scss?vue&type=style&index=0&id=4220c986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220c986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDatePicker,VMenu,VTextField})
